var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// import { fabric } from "fabric";
import intersect from "path-intersection";
import { PDF_DEFAULT_DPI } from "../../../common/constants/NcodeConstants";
import { IBrushType, PenEventName } from "../../../common/enums";
import { calcRevH } from "../../../common/mapper/CoordinateTanslater";
import { MappingStorage } from "../../../common/mapper/MappingStorage";
import { applyTransform } from "../../../common/math/echelon/SolveTransform";
import { NeoPdfRendererManager } from "../../../common/neopdf/NeoPdfRendererManager";
import { InkStorage } from "../../../common/penstorage";
import { StrokeStatus } from "../../../common/structures";
import { isSameH, isSamePage } from "../../../common/util";
import { PenManager } from "../../../neosmartpen";
import { FabricPath } from "../../PseudoFabric";
import { makeSvgPath } from "./renderer_utils";
import RenderWorkerBase from "./RenderWorkerBase";
import { createFabricPath, createPathData } from "./static_functions";
const NUM_HOVER_POINTERS = 6;
const DFAULT_BRUSH_SIZE = 10;
const REMOVE_HOVER_POINTS_INTERVAL = 50; // 50ms
// const DISABLED_STROKE_COLOR = "rgba(0, 0, 0, 0.1)";
// const INVISIBLE_STROKE_COLOR = "rgba(255, 255, 255, 0)";
// const INCOMPLETE_STROKE_COLOR = "rgba(255, 0, 255, 0.4)";
export const NAVYBLUE_STROKE_COLOR = "rgb(0,0,128)";
export const REPLAY_TIME_UNREACHED_OPACITY = 0.3;
export default class PenBasedRenderWorker extends RenderWorkerBase {
    /**
     *
     * @param options
     */
    constructor(options) {
        super(options);
        // localPathArray: IExtendedPathType[] = [];
        this.localPathArray = [];
        this.livePaths = {};
        this.visibleHoverPoints = NUM_HOVER_POINTERS;
        // penCursors: { [key: string]: IPenHoverCursors } = {};
        this._vpPenDownTime = 0;
        this.brushSize = DFAULT_BRUSH_SIZE;
        this._replay = {
            // imcompletedPath: undefined as fabric.Path,
            imcompletedPath: undefined,
        };
        this._pdfLayer = {
            img: {
                width: 0,
                height: 0,
                dataUrl: "",
                // fabricImg: undefined as fabric.Image,
                fabricImg: undefined,
            },
            rendering_queue: [],
            eventListenings: [],
        };
        this.pdfRenderingTask = undefined;
        //#region Pen Stroke 이벤트에 관한 처리
        /**
         * Pen Down이 들어왔다. 그러나 아직 page 정보가 들어오지 않아서,
         * 이 페이지에 붙여야 할 것인가 아니면, 새로운 페이지에 붙여야 할 것인가를 모른다.
         *
         * 렌더러 처리 순서
         * 1) Pen Down: live stroke의 path를 생성
         * 2) Page Info: 페이지를 전환하고, 잉크 스토리지에 있는 이전의 스트로크를 path로 등록한다.
         *      2-1) 이 클래스를 new 하는 container에서 setPageStrokePath(strokes)를 불러줘야 한다.
         * 3) Pen Move:
         *      3-1) live stroke path의 처음 나오는 점이면, path를 canvas에 등록한다.
         *      3-2) 두번째 점부터는 path에 append 한다.
         * 4) Pen Up: Live stroke path는 없애고, 잉크스토리지에 2) 이후의 stroke를 받아 path에 추가 등록한다.
         *
         *
         * 조심해야 할 것은, 위의 2의 처리를 container가 담당하고 있는데, 2에 앞서서 3이 처리되면
         * 이전의 페이지에 획이 추가되고, 2-1에 의해 clear되어 버린다. 순서에 유의할 것
         *
         * @public
         * @param {{strokeKey:string, mac:string, time:number, stroke:NeoStroke}} event
         */
        this.createLiveStroke = (event) => {
            this.livePaths[event.strokeKey] = {
                neoStroke: event.stroke,
                pathObj: null
            };
            // const cursor = this.getPenCursor(event.pen);
            // cursor.eraserLastPoint = undefined;
            // if (cursor) cursor.eraserLastDot = undefined;
        };
        this.discardLiveStroke = (strokeKey) => {
            delete this.livePaths[strokeKey];
        };
        this.createLiveStroke_byStorage = (event) => {
            this.createLiveStroke(event);
        };
        /**
         *
         * @param {{strokeKey:string, mac:string, stroke:NeoStroke, dot:NeoDot}} event
         */
        this.pushLiveDot = (event) => {
            var _a, _b;
            //pen tracker rendering
            const dot = event.dot;
            // const pdf_xy = this.ncodeToPdfXy(dot);
            let live = this.livePaths[event.strokeKey];
            if (!live) {
                live = {
                    neoStroke: event.stroke,
                    pathObj: null
                };
                this.livePaths[event.strokeKey] = live;
            }
            const pen = event.pen;
            if (pen && pen.penRendererType === IBrushType.ERASER) {
                //지우개 구현
                // const cursor = this.getPenCursor(event.pen);
                // if (cursor !== undefined && cursor.eraserLastDot !== undefined) {
                this.eraseOnLine(live.neoStroke, this.localPathArray.map(path => path.neoStroke), event.stroke.inputType);
                // this.eraseOnLine_old(
                //   cursor.eraserLastPoint.x, cursor.eraserLastPoint.y,
                //   pdf_xy.x, pdf_xy.y,
                //   live.neoStroke as IPageSOBP
                // );
                // }
                // cursor.eraserLastPoint = { x: pdf_xy.x, y: pdf_xy.y };
                // cursor.eraserLastDot = dot;
            }
            else {
                // 일반 획
                if (!live.pathObj) {
                    const new_pathObj = createFabricPath(live.neoStroke, false, this.ncodeToPdfXy, this._opt.opacityConverter);
                    // live.pathObj = new_pathObj as IExtendedPathType;
                    live.pathObj = new_pathObj;
                    (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.add(new_pathObj);
                }
                else {
                    // pathData = createPathData_arr(live.neoStroke, this.ncodeToPdfXy);
                    const pathData = createPathData(live.neoStroke, this.ncodeToPdfXy);
                    // pathData = createFabricPath(live.neoStroke, false, this.ncodeToPdfXy);
                    // const pathObj: IExtendedPathType = live.pathObj;
                    const pathObj = live.pathObj;
                    pathObj.path = pathData;
                }
                this.focusToDot(dot);
            }
            (_b = this.canvasFb) === null || _b === void 0 ? void 0 : _b.requestRenderAll();
        };
        this.pushLiveDot_byStorage = (event) => {
            var _a, _b;
            let live = this.livePaths[event.strokeKey];
            if (!live) {
                live = {
                    neoStroke: event.stroke,
                    pathObj: null
                };
                this.livePaths[event.strokeKey] = live;
            }
            const dot = event.dot;
            //지우개 구현
            // const canvas_xy = this.ncodeToPdfXy(dot);
            if (!live.pathObj) {
                const new_pathObj = createFabricPath(live.neoStroke, false, this.ncodeToPdfXy, this._opt.opacityConverter);
                // live.pathObj = new_pathObj as IExtendedPathType;
                live.pathObj = new_pathObj;
                (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.add(new_pathObj);
            }
            else {
                const pathData = createPathData(live.neoStroke, this.ncodeToPdfXy);
                // const pathObj = live.pathObj as fabric.Path;
                const pathObj = live.pathObj;
                pathObj.path = pathData;
            }
            this.focusToDot(dot);
            (_b = this.canvasFb) === null || _b === void 0 ? void 0 : _b.requestRenderAll();
        };
        /**
         *
         * @param {{strokeKey:string, mac:string, stroke, section:number, owner:number, book:number, page:number}} event
         */
        this.closeLiveStroke = (event) => {
            var _a, _b, _c, _d;
            const live = this.livePaths[event.strokeKey];
            if (!live)
                return;
            const pathObj = live.pathObj;
            if (pathObj) {
                pathObj.neoStroke = live.neoStroke;
                (_a = this.canvasFbCompleted) === null || _a === void 0 ? void 0 : _a.add(pathObj);
                (_b = this.canvasFbCompleted) === null || _b === void 0 ? void 0 : _b.renderObject(pathObj);
                this.localPathArray.push(pathObj);
                (_c = this.canvasFb) === null || _c === void 0 ? void 0 : _c.remove(pathObj);
                (_d = this.canvasFb) === null || _d === void 0 ? void 0 : _d.requestRenderAll();
            }
            delete this.livePaths[event.strokeKey];
        };
        /**
         *
         * @param {{strokeKey:string, mac:string, stroke, section:number, owner:number, book:number, page:number}} event
         */
        this.closeLiveStroke_byStorage = (event) => {
            this.closeLiveStroke(event);
        };
        //#endregion
        /**
         * 스트로크 단위로 들어온 지우개 움직임을 처리
         * 2021/06/20
         *
         * @private
         * @param {NeoStroke} eraserStroke
         * @memberof PenBasedRenderWorker
         */
        this.handleEraserStroke = (eraserStroke) => {
            // 적어도 선분은 이룰 수 있어야 하므로
            if (eraserStroke.dotArray.length < 2)
                return;
            // 현재 표시된 페이지와 eraser stroke의 페이지가 다르면, 잉크 스토리지에서 지운다
            const len = eraserStroke.dotArray.length;
            const sobp = eraserStroke;
            // const eraserBox = getBoundingBox(eraserStroke);
            const targetStrokes = this.storage.getPageStrokes(sobp)
                .filter(stroke => stroke.brushType !== IBrushType.ERASER &&
                stroke.status !== StrokeStatus.ERASED
            // hasIntersectRect(stroke.boundingBox, eraserBox)
            );
            this.eraseOnLine(eraserStroke, targetStrokes, eraserStroke.inputType);
            this.focusToDot(eraserStroke.dotArray[len - 1]);
        };
        /**
         * 지우개 모드일 때, collision test를 통해 지우는 것, 처리하는 방식이 이상하다.
         *
         * storage를 쓴다면, storage의 고유 기능으로 넣어야 할 것이고
         * storage 메시지를 renderer가 발신하고, renderer가 받고 있다는 것이 희안한 구조
         *
         * 아마 thumbnail을 모두 다시 그리는 데에, 메시지가 필요하지 않았을까 생각한다만, 해결책이 있을 것
         *
         * 대안)
         *    inkStorage가 event로 ON_STROKE_ERASED를 보낼 것
         *      인수로는 stroke를 보내고, event를 받은 worker는
         *
         *
         * 2021/06/09 kitty
         *
         *
         * Eraser stroke를 기준으로 collision test를 하는 것으로 바꿨다
         * 2021/06/20
         *
         * @private
         * @param {NeoStroke} eraserStroke
         * @param {NeoStroke[]} targetStrokes
         * @memberof PenBasedRenderWorker
         */
        this.eraseOnLine = (eraserStroke, targetStrokes, inputType) => {
            const len = eraserStroke.dotArray.length;
            if (len < 2)
                return;
            const sobp = eraserStroke;
            const dot0 = eraserStroke.dotArray[len - 2];
            const dot1 = eraserStroke.dotArray[len - 1];
            // const eraserStrokeSvg = makeSvgPath(eraserStroke.dotArray);
            const eraserSvgPathData = 'M ' + dot0.x + ' ' + dot0.y +
                ' L ' + dot1.x + ' ' + dot1.y + 'z';
            for (const target of targetStrokes) {
                const pointArray = target.dotArray;
                const pathDataStr = makeSvgPath(pointArray);
                const intersection = intersect(pathDataStr, eraserSvgPathData);
                if ((intersection === null || intersection === void 0 ? void 0 : intersection.length) > 0) {
                    this.storage.markStrokeErased(target.key, eraserStroke, sobp, inputType);
                }
            }
        };
        /**
         * 위의 redrawStrokes의 개선 버전, 지우개 이동시 해당하는 stroke만 erased로 marking
         * 렌더러에서 해당 획만 제외
         *
         * @param {*} pageInfo
         * @memberof PenBasedRenderWorker
         */
        this.onStrokeErased = (event) => {
            var _a, _b;
            for (const stroke of event.erasedStrokes) {
                const sobp = stroke;
                if (isSamePage(this.pageInfo, sobp)) {
                    const idx = this.localPathArray.findIndex(path => path.key === stroke.key);
                    if (idx > -1) {
                        const foundPaths = this.localPathArray[idx];
                        (_a = this.canvasFbCompleted) === null || _a === void 0 ? void 0 : _a.remove(foundPaths);
                        this.localPathArray.splice(idx, 1);
                    }
                }
            }
            (_b = this.canvasFbCompleted) === null || _b === void 0 ? void 0 : _b.requestRenderAll();
        };
        /**
         * 렌더러의 페이지를 바꿔 주는 곳
         * 1) 캔버스를 모두 지우고, 2) 스트로크를 채워 넣어서, 3) Live stroke가 들어오는 준비를 한다
         *
         * @param {IPageSOBP} pageInfo
         * @param {NeoStroke[]} strokes - page에 들어 있는 stroke, inkStorage에서 받아온 것,
         *                                상위 객체에서 넣어주는 이유는 pen 배열을 상위 객체가 가지고 있기 때문
         *                                그리고, 상위 객체가 replay 인지 아닌지 여부에 따라 받아오는 stroke가 달라서
         * @param {ISize} size_pu
         * @param {TransformParameters} h
         * @param {NeoPdfDocument} pdf
         * @param {number} pdfPageNo
         * @memberof PenBasedRenderWorker
         */
        this.lastPdf = null;
        this.lastPdfPageNo = -1;
        this.lastSizePu = null;
        this.changePage_20210418 = (pageInfo, strokes, size_pu, h, pdf, pdfPageNo, forceRenderStroke) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            let updatePdfOnly = false;
            if ((!forceRenderStroke)
                && isSamePage(this.pageInfo, pageInfo)
                && isSameH(this.h, h)
                && ((_a = this.lastSizePu) === null || _a === void 0 ? void 0 : _a.width) === (size_pu === null || size_pu === void 0 ? void 0 : size_pu.width)
                && ((_b = this.lastSizePu) === null || _b === void 0 ? void 0 : _b.height) === (size_pu === null || size_pu === void 0 ? void 0 : size_pu.height)) {
                if (this.lastPdf === pdf && this.lastPdfPageNo === pdfPageNo) {
                    return;
                }
                // page size 관련된 것 세팅
                updatePdfOnly = true;
            }
            this.lastPdf = pdf;
            this.lastPdfPageNo = pdfPageNo;
            this.lastSizePu = Object.assign({}, size_pu);
            this._opt.pdf = pdf;
            this._opt.pdfPageNo = pdfPageNo;
            if ((!forceRenderStroke) && updatePdfOnly) {
                this.onPageSizeChanged(size_pu);
            }
            else {
                this.pageInfo = pageInfo;
                // H 관련된 것 세팅
                this.setTransformParameters(h);
                const h_rev = calcRevH(h);
                const leftTop_nu = applyTransform({ x: 0, y: 0 }, h_rev);
                this.paperBase = { Xmin: leftTop_nu.x, Ymin: leftTop_nu.y };
                // 페이지의 모든 데이터를 지우고
                this.removeAllCanvasObject();
                this.resetLocalPathArray();
                console.log(`image changePage_20210418, ${pdf === null || pdf === void 0 ? void 0 : pdf.filename}, ${pdfPageNo}`);
                // page size 관련된 것 세팅
                this.onPageSizeChanged(size_pu);
                // TODO: kitty, 2022/11/23, 안되면 force = true로
                const pr = this.changePdfPage(pdf, pdfPageNo, false);
                // this.resetPageDependentData();
                // stroke 관련된 것 세팅
                this.addStrokePaths(strokes);
                // 2022/11/19
                (_c = this.canvasFbPdf) === null || _c === void 0 ? void 0 : _c.requestRenderAll();
                (_d = this.canvasFbCompleted) === null || _d === void 0 ? void 0 : _d.requestRenderAll();
                (_e = this.canvasFb) === null || _e === void 0 ? void 0 : _e.requestRenderAll();
                yield pr;
            }
        });
        this.getViewSize = () => {
            return {
                sobp: this.pageInfo,
                width_pu: this._opt.pageSize_pu.width,
                height_pu: this._opt.pageSize_pu.height
            };
        };
        this.generatePdfImageDataUrl = (pdf, pdfPageNo) => __awaiter(this, void 0, void 0, function* () {
            const page = pdf.getPage(pdfPageNo);
            const sz = page.getSize();
            // const width_to_draw = this.canvasFbPdf.width;
            // const height_to_draw = this.canvasFbPdf.height;
            // const scale = Math.min(width_to_draw / sz.width, height_to_draw / sz.height);
            const scale = this.offset.zoom;
            const dpi = Math.round(scale * PDF_DEFAULT_DPI);
            let task;
            let dataUrl = "";
            let renderedWidth = 0;
            let renderedHeight = 0;
            try {
                if (this.pdfRenderingTask) {
                    this.pdfRenderingTask.cancel();
                    this.pdfRenderingTask = undefined;
                }
                task = NeoPdfRendererManager.instance.requestRenderPageAsync({
                    page,
                    renderContext: undefined,
                    topPriority: this._opt.isPriorityView,
                    dpi,
                    type: "png",
                });
                this.pdfRenderingTask = task;
                const ret = yield task.promise;
                this.pdfRenderingTask = undefined;
                const u8 = ret.png;
                renderedHeight = ret.renderedHeight;
                renderedWidth = ret.renderedWidth;
                let binary = '';
                for (let i = 0, len = u8.length; i < len; i++)
                    binary += String.fromCharCode(u8[i]);
                const b64encoded = btoa(binary);
                dataUrl = "data:image/png;base64," + b64encoded;
            }
            catch (e) {
                console.log(`rendering cancelled: page: ${pdfPageNo}`);
                return undefined;
            }
            return { dataUrl, width_pu: sz.width, height_pu: sz.height, page, renderedHeight, renderedWidth };
        });
        this.reloadHomography = () => {
            // 2021/07/19 PDF가 처음 로드되고 나서, H를 세팅해 줘야 한다.
            const msi = MappingStorage.getInstance();
            const transform = msi.getNPageTransform(this.pageInfo);
            const h = transform.h;
            if (h.a !== this.h.a || h.e !== this.h.e ||
                h.b !== this.h.b ||
                h.c !== this.h.c ||
                h.d !== this.h.d ||
                h.f !== this.h.f ||
                h.g !== this.h.g ||
                h.h !== this.h.h) {
                const h_rev = this.setTransformParameters(h);
                const leftTop_nu = applyTransform({ x: 0, y: 0 }, h_rev);
                this.paperBase = { Xmin: leftTop_nu.x, Ymin: leftTop_nu.y };
            }
            // page size 관련된 것 세팅
            const pageDesc = msi.getAssociatedPdfPage(this.pageInfo);
            const size_pu = pageDesc === null || pageDesc === void 0 ? void 0 : pageDesc.pageMapping.pdfDesc.size_pu;
            if (size_pu &&
                (size_pu.width !== this._opt.pageSize_pu.width ||
                    size_pu.height !== this._opt.pageSize_pu.height)) {
                this.onPageSizeChanged(size_pu);
            }
            // 2021/07/09/여기까지
        };
        this.changePdfPage = (pdf, pdfPageNo, force) => __awaiter(this, void 0, void 0, function* () {
            var _f, _g, _h, _j, _k;
            if (this._opt.pdf === pdf && this._opt.pdfPageNo === pdfPageNo && (!force))
                return;
            this._opt.pdf = pdf;
            this._opt.pdfPageNo = pdfPageNo;
            if (!pdf) {
                (_f = this.canvasFbPdf) === null || _f === void 0 ? void 0 : _f.setSize(0, 0);
                (_g = this.canvasFbPdf) === null || _g === void 0 ? void 0 : _g.setVisibility(false);
                // this.canvasFbPdf?.setImageUrl("");
                return;
            }
            // pdf rendering에 대한 event 수신
            if (pdf) { // if문은 2021/07/17에 추가, dummy page가 있을 수 있다
                const pageImage = yield this.generatePdfImageDataUrl(pdf, pdfPageNo);
                if (pageImage && pageImage.page.pageNo === this._opt.pdfPageNo && pageImage.page._doc === this._opt.pdf) {
                    this.reloadHomography();
                    const { width, height } = this._opt.pageSize_pu;
                    const { zoom } = this.offset;
                    (_h = this.canvasFbPdf) === null || _h === void 0 ? void 0 : _h.setSize(width * zoom, height * zoom);
                    (_j = this.canvasFbPdf) === null || _j === void 0 ? void 0 : _j.setVisibility(true);
                    (_k = this.canvasFbPdf) === null || _k === void 0 ? void 0 : _k.setImageUrl(pageImage.dataUrl);
                }
            }
        });
        //#endregion
        /**
         * @private
         */
        this.resetLocalPathArray = () => {
            this.localPathArray = new Array(0);
        };
        /**
         * @private
         */
        this.removeAllPaths = () => {
            if (!this.canvasFb)
                return;
            this.localPathArray.forEach(path => {
                var _a;
                (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.remove(path);
            });
            this.localPathArray = new Array(0);
        };
        /**
         * @private
         */
        this.removeAllStrokeObject = () => {
            var _a;
            if (this.canvasFb) {
                const objects = (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.getObjects();
                const strokes = objects.filter(obj => !!obj.data.isStroke);
                strokes.forEach((path) => {
                    var _a;
                    (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.remove(path);
                });
            }
        };
        this.removeAllCanvasObjectProc = (canvas) => {
            if (canvas) {
                const objects = canvas.getObjects();
                const needToClear = objects.filter(obj => (obj.data !== 'hps' && obj.data !== 'pt' && obj.name !== 'page_layout'));
                needToClear.forEach(o => canvas.remove(o));
                // canvas.remove(...needToClear);
            }
        };
        this.removeAllCanvasObject = () => {
            this.removeAllCanvasObjectProc(this.canvasFb);
            this.removeAllCanvasObjectProc(this.canvasFbCompleted);
        };
        /**
         * Remote pen에서 나오는 network stroke
         *
         * @param {IPenToViewerEvent} event
         * @memberof PenBasedRenderWorker
         */
        this.handleStrokeReceived = (event) => {
            if (event.stroke && isSamePage(event.stroke, this.pageInfo)) {
                this.addStrokePaths([event.stroke]);
            }
        };
        /**
         * 스트로크 단위로 들어온 path에 대해서, renderer에 추가한다.
         * 네트워크 펜에서 들어오는 경우가 아래의 흐름을 탄다.
         *
         * @param {NeoStroke[]} strokes
         * @memberof PenBasedRenderWorker
         */
        this.addStrokePaths = (strokes) => {
            var _a;
            if (!this.canvasFbCompleted)
                return;
            strokes.forEach((stroke) => {
                var _a;
                if (stroke.dotArray.length < 1)
                    return;
                // const path = createFabricPath(stroke, true, this.ncodeToPdfXy, this._opt.opacityConverter) as IExtendedPathType;
                const path = createFabricPath(stroke, true, this.ncodeToPdfXy, this._opt.opacityConverter);
                (_a = this.canvasFbCompleted) === null || _a === void 0 ? void 0 : _a.add(path);
                this.localPathArray.push(path);
                // console.log(`${this._opt.id}, localPathArray=${this.localPathArray.length}`)
            });
            (_a = this.canvasFbCompleted) === null || _a === void 0 ? void 0 : _a.renderAll();
            // 맨 마지막에 들어온 dot으로 focus를 맞춘다. 2021/06/06 kitty
            const lastStroke = strokes[strokes.length - 1];
            if (lastStroke) {
                const lastDot = lastStroke.dotArray[lastStroke.dotArray.length - 1];
                if (lastDot) {
                    this.focusToDot(lastDot);
                }
            }
        };
        // private handleStrokeErased = (erasedStrokeKey: string, sobp: IPageSOBP) => {
        //   this.storage.markStrokeErased(erasedStrokeKey, sobp);
        // }
        //#region Mouse Pen 관련된 처리
        /**
         * 아래는 마우스로 그림을 그리는 곳 (Pen down)
         * WorkerBase의 abstract 함수를 참조
         *
         * @param {MouseEvent} event
         * @memberof PenBasedRenderWorker
         */
        this.onTouchStrokePenDown = (event) => {
            if (this.pageInfo) {
                const timeStamp = Date.now();
                this._vpPenDownTime = timeStamp;
                const vp = PenManager.getInstance().getVirtualPen();
                vp.onPenDown({ timeStamp, penTipMode: 0, mac: vp.mac });
                vp.onPageInfo(Object.assign(Object.assign({}, this.pageInfo), { timeStamp }), false);
                return true;
            }
            return false;
        };
        /**
         * 아래는 마우스로 그림을 그리는 곳 (Pen move)
         * WorkerBase의 abstract 함수를 참조
         *
         * @param {MouseEvent} event
         * @param {{ x: number, y: number }} canvasXy
         * @param {number} force
         * @memberof PenBasedRenderWorker
         */
        this.onTouchStrokePenMove = (event, canvasXy, force) => {
            const ncode_xy = this.pdfToNcodeXy(canvasXy);
            const vp = PenManager.getInstance().getVirtualPen();
            const timeStamp = Date.now();
            const timediff = timeStamp - this._vpPenDownTime;
            vp.onPenMove(Object.assign(Object.assign(Object.assign({}, this.pageInfo), ncode_xy), { force: force, timeStamp, timediff, isFirstDot: false }));
        };
        /**
         * 아래는 마우스로 그림을 그리는 곳 (Pen up)
         * WorkerBase의 abstract 함수를 참조
         *
         * @param {MouseEvent} event
         * @memberof PenBasedRenderWorker
         */
        this.onTouchStrokePenUp = (event) => {
            const vp = PenManager.getInstance().getVirtualPen();
            const timeStamp = Date.now();
            vp.onPenUp({ timeStamp });
        };
        //#endregion
        this.onViewSizeChanged = (viewSize) => {
            this._opt.viewSize = Object.assign({}, viewSize);
            // console.log(`VIEW SIZE${callstackDepth()} onViewSizeChanged ${this.logCnt++}: ${viewSize.width}, ${viewSize.height}`);
            const zoom = this.calcScaleFactor(this._opt.viewFit, this.offset.zoom);
            this.drawPageLayout();
            this.scrollBoundaryCheck(Object.assign({}, this.offset));
            this.zoomToPoint(undefined, zoom);
            if (this.offset.zoom !== zoom) {
                this.changePdfPage(this._opt.pdf, this._opt.pdfPageNo, true);
            }
        };
        this.onPageSizeChanged = (pageSize_pu) => {
            var _a, _b;
            if (this._opt.pageSize_pu) {
                const { width: w0, height: h0 } = this._opt.pageSize_pu;
                const { width: w1, height: h1 } = pageSize_pu;
                if (w0 === w1 && h0 === h1)
                    return false;
            }
            this._opt.pageSize_pu = Object.assign({}, pageSize_pu);
            if (this.pageInfo === undefined || this.pageInfo.section === undefined)
                return false;
            const zoom = this.calcScaleFactor(this._opt.viewFit, this.offset.zoom);
            this.drawPageLayout();
            this.scrollBoundaryCheck(Object.assign({}, this.offset));
            this.zoomToPoint(undefined, zoom);
            // 2022/11/17
            this.zoomCanvas(zoom, true);
            if (this._opt.pdf && this._opt.pdfPageNo) {
                (_a = this.canvasFbPdf) === null || _a === void 0 ? void 0 : _a.setSize(pageSize_pu.width * zoom, pageSize_pu.height * zoom);
                (_b = this.canvasFbPdf) === null || _b === void 0 ? void 0 : _b.setZoom(zoom);
                // this.changePdfPage(this._opt.pdf, this._opt.pdfPageNo, true);
            }
            return true;
        };
        /**
         * WorkerBase에서 올라오는 이벤트
         *
         * @param {number} zoom
         * @memberof PenBasedRenderWorker
         */
        this.onZoomChanged = (zoom) => {
            if (this._opt.pdf && this._opt.pdfPageNo) {
                this.changePdfPage(this._opt.pdf, this._opt.pdfPageNo, true);
            }
        };
        //#region 펜 커서 관련된 부분
        this.movePenTracker = (event) => {
            var _a;
            const dot = event.dot;
            const canvas_xy = this.funcNcodeToPdfXy(dot);
            const z = (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.getZoom();
            this._opt.reportCursorMoveFn(canvas_xy.x * z, canvas_xy.y * z, true, "cursor");
        };
        this.changeDrawCursor = () => {
            this.canvasFb.hoverCursor = `url(${this.getDrawCursor()}) ${this.brushSize / 2} ${this.brushSize / 2}, crosshair`;
        };
        this.getDrawCursor = () => {
            const color = PenManager.getInstance().color;
            const pen_colors = PenManager.getInstance().pen_colors;
            const foundIdx = pen_colors.findIndex(ele => ele === color);
            let brushColor;
            switch (foundIdx) {
                case 1:
                    brushColor = 'red';
                    break;
                case 2:
                    brushColor = 'yellow';
                    break;
                case 3:
                    brushColor = 'navy';
                    break;
                case 4:
                    brushColor = 'black';
                    break;
                case 5:
                    brushColor = 'white';
                    break;
                case 6:
                    brushColor = 'orange';
                    break;
                case 7:
                    brushColor = 'green';
                    break;
                case 8:
                    brushColor = 'blue';
                    break;
                case 9:
                    brushColor = 'purple';
                    break;
                case 0:
                    brushColor = 'darkgray';
                    break;
            }
            const circle = `
      <svg
        height="${this.brushSize}"
        fill="${brushColor}"
        viewBox="0 0 ${this.brushSize * 2} ${this.brushSize * 2}"
        width="${this.brushSize}"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="50%"
          cy="50%"
          r="${this.brushSize}"
        />
      </svg>
    `;
            return `data:image/svg+xml;base64,${window.btoa(circle)}`;
        };
        this.moveHoverPoint = (e) => {
            var _a;
            // const cursor = this.getPenCursor(e.pen);
            // if (!cursor) {
            //   console.error(`ERROR: pen cursor has not been initiated`);
            //   return;
            // }
            const dot = { x: e.event.x, y: e.event.y };
            const canvas_xy = this.funcNcodeToPdfXy(dot);
            const z = (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.getZoom();
            this._opt.reportCursorMoveFn(canvas_xy.x * z, canvas_xy.y * z, true, "hover");
            // const hps = cursor.hoverPoints;
            // const isPointerVisible = this._opt.laserPointer;
            // // hover point를 쉬프트해서 옮겨 놓는다
            // for (let i = NUM_HOVER_POINTERS - 1; i > 0; i--) {
            //   hps[i].set({ left: hps[i - 1].left, top: hps[i - 1].top });
            //   hps[i].setCoords();
            // }
            // const r = hps[0].radius;
            // hps[0].set({ left: canvas_xy.x - r, top: canvas_xy.y - r });
            // hps[0].setCoords();
            // cursor.visibleHoverPoints = NUM_HOVER_POINTERS;
            // for (let i = 0; i < cursor.visibleHoverPoints; i++) {
            //   hps[i].visible = isPointerVisible;
            // }
            // this.canvasFb.requestRenderAll();
            // if (cursor.intervalHandle) {
            //   clearInterval(cursor.intervalHandle);
            //   cursor.intervalHandle = 0;
            // }
            // cursor.waitCount = 0;
            // const self = this;
            // cursor.intervalHandle = window.setInterval(() => {
            //   const cursor = this.getPenCursor(e.pen);
            //   if (!cursor) {
            //     console.error(`ERROR: pen cursor has not been initiated`);
            //     // clearInterval(cursor.intervalHandle);
            //     return;
            //   }
            //   const hps = cursor.hoverPoints;
            //   cursor.waitCount++;
            //   // 1초 뒤
            //   if (cursor.waitCount > 20) {
            //     for (let i = NUM_HOVER_POINTERS - 1; i > 0; i--) {
            //       hps[i].left = hps[i - 1].left;
            //       hps[i].top = hps[i - 1].top;
            //     }
            //     hps[0].left = -30;
            //     hps[0].top = -30;
            //     cursor.visibleHoverPoints--;
            //     if (cursor.visibleHoverPoints >= 0) {
            //       hps[cursor.visibleHoverPoints].visible = false;
            //       self.canvasFb.requestRenderAll();
            //     } else {
            //       clearInterval(cursor.intervalHandle);
            //     }
            //   }
            // }, REMOVE_HOVER_POINTS_INTERVAL);
        };
        // 2021/04/01
        // private registerPenCursor = (pen: INeoSmartpen, props: IPenHoverCursors) => {
        //   const penUID = pen.inputType.type + "/" + pen.mac;
        //   this.penCursors[penUID] = props;
        // }
        // // 2021/04/01
        // private getPenCursor = (pen: INeoSmartpen): IPenHoverCursors => {
        //   const penUID = pen?.inputType?.type + "/" + pen?.mac;
        //   if (penUID)
        //     return this.penCursors[penUID];
        //   return null;
        // }
        // // 2021/04/01
        // private removePenCursor = (pen: INeoSmartpen) => {
        //   const penUID = pen.inputType.type + "/" + pen.mac;
        //   delete this.penCursors[penUID];
        // }
        // //#endregion
        // 2021/04/18
        this.setReplayAbsTime = (absTime) => {
            var _a, _b, _c;
            // let incompletedStroke: fabric.Path = undefined;
            let incompletedStroke = undefined;
            let lastVisibleStroke = undefined;
            this.localPathArray.forEach(path => {
                const data = path.data;
                if (data.stroke.endTime <= absTime) {
                    // 획이 완성된 것이라면
                    path.color = data.color;
                    path.fill = data.color;
                    path.opacity = data.opacity;
                    // 시간 순서로 sorting되어 있기 때문에 이렇게 써도 될 듯
                    lastVisibleStroke = data.stroke;
                }
                else {
                    // 그리고 있는 중간이라면
                    if (data.stroke.startTime <= absTime) {
                        incompletedStroke = path;
                        // path.opacity = 0;
                    }
                    // 아직 그리지 않은 것이라면
                    path.color = data.color;
                    path.fill = data.color;
                    path.opacity = data.opacity * REPLAY_TIME_UNREACHED_OPACITY;
                }
            });
            if (incompletedStroke) {
                const lastDot = this.drawIncompletedPath(incompletedStroke, absTime);
                if (lastDot) {
                    this.focusToDot(lastDot);
                }
            }
            else {
                // focus를 맞춘다
                if (lastVisibleStroke) {
                    const len = lastVisibleStroke.dotArray.length;
                    this.focusToDot(lastVisibleStroke.dotArray[len - 1]);
                }
                if (this._replay.imcompletedPath) {
                    (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.remove(this._replay.imcompletedPath);
                    this._replay.imcompletedPath = undefined;
                    (_b = this.canvasFb) === null || _b === void 0 ? void 0 : _b.requestRenderAll();
                }
            }
            (_c = this.canvasFbCompleted) === null || _c === void 0 ? void 0 : _c.requestRenderAll();
        };
        /**
         *
         *
         * @private
         * @param {fabric.Path} path
         * @param {number} absTime
         *
         * @return {NeoDot} - 맨 마지막 점
         * @memberof PenBasedRenderWorker
         */
        this.drawIncompletedPath = (path, absTime) => {
            var _a, _b;
            const stroke = path.data.stroke;
            if (!this._replay.imcompletedPath) {
                const pathOption = this.createReplayLivePathOption(stroke);
                // this._replay.imcompletedPath = new fabric.Path("", pathOption);
                this._replay.imcompletedPath = new FabricPath("", pathOption);
                (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.add(this._replay.imcompletedPath);
            }
            // const strokeStartTime = stroke.startTime;
            const dotArray = stroke.dotArray.filter(dot => dot.time < absTime).map(d => {
                const f = d.f * 4;
                return Object.assign(Object.assign({}, d), { f });
            });
            const st = Object.assign(Object.assign({}, stroke), { dotArray });
            // console.log(`draw incompleted = ${dotArray.length}`);
            const pathData = createPathData(st, this.ncodeToPdfXy);
            this._replay.imcompletedPath.path = pathData;
            this._replay.imcompletedPath.opacity = path.data.opacity;
            this._replay.imcompletedPath.dirty = true;
            (_b = this.canvasFb) === null || _b === void 0 ? void 0 : _b.requestRenderAll();
            return dotArray[dotArray.length - 1];
        };
        this.createReplayLivePathOption = (stroke) => {
            const color = stroke.color;
            // TODO: 충남교육청, NEP에서는 아래를 쓸 것, 어떻게 해야하지?
            // const c = color === "#000000" ? NAVYBLUE_STROKE_COLOR : color;
            const c = color;
            let opacity = 0;
            switch (stroke.brushType) {
                case IBrushType.PEN:
                    opacity = 1;
                    break;
                case IBrushType.MARKER:
                    opacity = 0.3;
                    break;
                case IBrushType.ERASER:
                    opacity = 0;
                    break;
                case IBrushType.ERASED:
                    opacity = 0;
                    break;
                default:
                    opacity = 1;
                    break;
            }
            const pathOption = {
                // stroke: color, //"rgba(0,0,0,255)"
                fill: "#f00",
                color: "#f00",
                opacity: 1,
                strokeWidth: 2,
                originX: 'left',
                originY: 'top',
                selectable: false,
                data: { isStroke: true, color: c, stroke, opacity },
                evented: true,
                key: stroke.key,
                objectCaching: false,
            };
            return pathOption;
        };
        this.name = "PenBasedRenderWorker";
        const { storage } = options;
        if (storage !== undefined) {
            if (!(storage instanceof InkStorage)) {
                throw new Error("storage is not an instance of InkStorage");
            }
            this.storage = storage;
        }
        this.changeDrawCursor();
        const penManager = PenManager.getInstance();
        penManager.addEventListener(PenEventName.ON_COLOR_CHANGED, this.changeDrawCursor);
        // this.changePage(this.pageInfo, options.pageSize_pu, true);
        // const transform = MappingStorage.getInstance().getNPageTransform(this.pageInfo);
        // this.changePage_20210418(this.pageInfo, [], options.pageSize_pu, transform.h);
    }
    prepareUnmount() {
        var _a;
        (_a = this.pdfRenderingTask) === null || _a === void 0 ? void 0 : _a.cancel();
        super.prepareUnmount();
        const penManager = PenManager.getInstance();
        penManager.removeEventListener(PenEventName.ON_COLOR_CHANGED, this.changeDrawCursor);
        const propKeys = Object.keys(this._opt);
        for (let i = 0, ln = propKeys.length; i < ln; i++) {
            const key = propKeys[i];
            delete this._opt[key];
            this._opt[key] = undefined;
        }
    }
}
//# sourceMappingURL=PenBasedRenderWorker.js.map